import React, {Component} from 'react'
import {
  Spin,
  Form,
  Row,
  Select,
  DatePicker,
  Col,
  Card,
  Button,
  Input,
  notification,
} from 'antd'
import {connect} from 'react-redux'
import axios from 'axios'
import Moment from 'moment'
import {decode} from 'utf8'
import TableNotify from './TableNotify'
import getDate from 'util/ConfigDates'
import {fetchCompanies, fetchDataCompanies} from 'appRedux/actions/Companies'
import './styles.css'
const Option = Select.Option
const FormItem = Form.Item
const {TextArea} = Input

class DestinationData extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateFrom: getDate('dateFrom'),
      dateTo: getDate('dateTo'),
      idCompany: 0,
      validate: 'error',
      help: 'Este es un campo obligatorio.',
      destiny: 0,
      tokensSelected: [],
      idsSelected: [],
      arrayholder: [],
      vendorsData: [],
      error: false,
      error1: false,
      title: '',
      subTitle: '',
      typeNotification: 0,
      imageUrl: '',
      description: '',
      loading: false,
    }
  }

  componentDidMount() {
    this.props.fetchCompanies()
    this.takeDataVendors()
  }

  onClickDateFrom = (date, dateString) => {
    this.setState({
      dateFrom: dateString,
    })
  }

  onClickDateTo = (date, dateString) => {
    this.setState({dateTo: dateString})
  }

  arrayC = () => {
    let array = this.props.companies
    return array.map((element, index) => {
      return (
        <Option key={index} value={element.id}>
          {element.name}
        </Option>
      )
    })
  }

  handleChangeCombo = value => {
    const arrTokens = this.state.vendorsData.map(vendor => {
      if (vendor.companyId === value) {
        return vendor.token
      }
    })

    const arrIds = this.state.vendorsData.map(vendor => {
      if (vendor.companyId === value) {
        return vendor.staff_id
      }
    })

    this.setState({
      idCompany: value,
      tokensSelected: arrTokens.filter(value => value != undefined),
      idsSelected: arrIds.filter(value => value != undefined),
    })
  }

  handleChangeDestiny = value => {
    this.setState({tokensSelected: [], idsSelected: []})

    if (value === 1) {
      const arrTokens = this.state.vendorsData.map(value => {
        if (value.token != undefined) {
          return value.token
        }
      })

      const arrIds = this.state.vendorsData.map(vendor => {
        if (vendor.companyId === value) {
          return vendor.staff_id
        }
      })

      this.setState(({vendorsData}) => ({
        tokensSelected: arrTokens.filter(value => value != undefined),
        idsSelected: arrIds.filter(value => value != undefined),
      }))
    }

    this.setState({
      destiny: value,
    })
  }

  handleChangeType = value => {
    this.setState({
      typeNotification: value,
    })
  }

  showTable = () => {
    if (this.state.destiny === 2) {
      return (
        <Card>
          <input
            placeholder="Buscar por nombre"
            onChange={e => {
              if (e.target.value >= 0) {
                const newDataNumber = this.state.arrayholder.filter(item => {
                  const itemData = item.identifier
                  const textData = e.target.value
                  return itemData.indexOf(textData) > -1
                })

                this.setState({vendorsData: newDataNumber})
              } else {
                const newData = this.state.arrayholder.filter(item => {
                  const itemData = item.name.toLowerCase()
                  const textData = e.target.value.toLowerCase()
                  return itemData.indexOf(textData) > -1
                })

                this.setState({vendorsData: newData})
              }
            }}
            className="input-search "
          />
          <TableNotify
            onPressCheck={this.onPressCheck}
            dataSource={this.state.vendorsData}
            tokensSelected={this.state.tokensSelected}
          />
        </Card>
      )
    }
  }

  takeDataVendors = async () => {
    await _getDataVendors().then(res => {
      if (res.success === '1') {
        this.setState({
          vendorsData: res.result,
          arrayholder: res.result,
        })
      } else {
        console.log('error')
      }
    })
  }

  onPressCheck = record => {
    if (
      !this.state.tokensSelected.includes(record.token) &&
      record.token != undefined
    ) {
      this.setState({
        tokensSelected: [...this.state.tokensSelected, record.token],
        idsSelected: [...this.state.idsSelected, record.staff_id],
      })
    } else {
      this.setState({
        tokensSelected: this.state.tokensSelected.filter(
          value => value !== record.token,
        ),
        idsSelected: this.state.idsSelected.filter(
          value => value !== record.staff_id,
        ),
      })
    }
  }

  onChangeTitle = event => {
    this.setState({
      title: event.target.value,
    })

    if (event.target.value != '') {
      this.setState({
        error: false,
      })
    } else {
      this.setState({
        error: true,
      })
    }
  }

  onChangeDescription = event => {
    this.setState({
      description: event.target.value,
    })
  }

  handlChangeImage = selectorFiles => {
    const file = selectorFiles[0]
    this.setState({imageUrl: file})
  }

  onSendNotification = type => {
    this.onNotification(type)
    this.setState({
      title: '',
      subTitle: '',
      description: '',
      idsSelected: [],
      tokensSelected: [],
      typeNotification: 0,
      idCompany: 0,
      imageUrl: '',
      destiny: 0,
    })
    this.takeDataVendors()
  }

  onPressSend = async () => {
    const {dateFrom, dateTo, title, subTitle, description} = this.state
    if (
      dateFrom != '' &&
      dateTo != '' &&
      title != '' &&
      subTitle != '' &&
      description != ''
    ) {
      this.setState({loading: true})
      await getIdNotification(this.state).then(res => {
        this.setState({loading: false})
        if (res.success === 1) {
          this.onSendNotification('success')
        } else {
          this.onSendNotification('error')
        }
      })
    } else {
      notification['error']({
        message: 'Error',
        description: 'Todos los campos son requeridos.',
      })
    }
  }

  onChangeSubTitle = event => {
    this.setState({
      subTitle: event.target.value,
    })

    if (event.target.value != '') {
      this.setState({
        error1: false,
      })
    } else {
      this.setState({
        error1: true,
      })
    }
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'La notificación se ha enviado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al enviar la notificación.',
      })
    }
  }

  render() {
    const {
      idCompany,
      dateFrom,
      dateTo,
      validate,
      help,
      typeNotification,
      title,
      subTitle,
    } = this.state

    if (this.state.loading) {
      return <Spin className="gx-loader-container" />
    }

    return (
      <React.Fragment>
        <Card>
          <Form>
            <Row>
              <Col span={10}>
                <FormItem
                  label="Desde *:"
                  validateStatus={dateFrom !== '' ? '' : validate}
                  help={dateFrom !== '' ? '' : help}
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                >
                  <DatePicker
                    defaultValue={Moment(dateFrom, 'YYYY-MM-DD')}
                    className="gx-mb-3 gx-w-100"
                    onChange={this.onClickDateFrom}
                  />
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem
                  label="Hasta *: "
                  validateStatus={dateTo !== '' ? '' : validate}
                  help={dateTo !== '' ? '' : help}
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                >
                  <DatePicker
                    defaultValue={Moment(dateTo, 'YYYY-MM-DD')}
                    className="gx-mb-3 gx-w-100"
                    onChange={this.onClickDateTo}
                  />
                </FormItem>
              </Col>

              <Col span={10}>
                <FormItem
                  label="Destinatario *"
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                  validateStatus={idCompany !== '' ? '' : validate}
                  help={idCompany !== '' ? '' : help}
                >
                  <Select
                    className="gx-mr-3 gx-mb-3"
                    defaultValue="Seleccionar *"
                    onChange={this.handleChangeDestiny}
                    style={{width: 140}}
                  >
                    <Option key={1} value={1}>
                      Todos
                    </Option>
                    <Option key={2} value={2}>
                      Segmentado
                    </Option>
                    <Option key={3} value={3}>
                      Compañía
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              {this.state.destiny === 3 ? (
                <Col span={10}>
                  <FormItem
                    label="Compañía *"
                    labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                    validateStatus={idCompany !== '' ? '' : validate}
                    help={idCompany !== '' ? '' : help}
                  >
                    <Select
                      className="gx-mr-3 gx-mb-3"
                      defaultValue="Seleccionar"
                      onChange={this.handleChangeCombo}
                      style={{width: 140}}
                    >
                      {this.arrayC()}
                    </Select>
                  </FormItem>
                </Col>
              ) : null}
            </Row>
          </Form>
        </Card>

        {this.showTable()}

        <Card>
          <Form>
            <Row>
              <Col span={10}>
                <FormItem
                  label="Título *"
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                  validateStatus={this.state.error ? validate : ''}
                  help={this.state.error ? help : ''}
                >
                  <Input
                    required
                    placeholder="Título"
                    value={this.state.title}
                    onChange={this.onChangeTitle}
                  />
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem
                  label="Subtítulo  *"
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                  validateStatus={this.state.error1 ? validate : ''}
                  help={this.state.error1 ? help : ''}
                >
                  <Input
                    required
                    placeholder="Subtítulo"
                    value={this.state.subTitle}
                    onChange={this.onChangeSubTitle}
                  />
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem
                  label="Tipo *"
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                  validateStatus={typeNotification !== '' ? '' : validate}
                  help={typeNotification !== '' ? '' : help}
                >
                  <Select
                    className="gx-mr-3 gx-mb-3"
                    defaultValue="Seleccionar"
                    onChange={this.handleChangeType}
                    style={{width: 140}}
                  >
                    <Option key={1} value={1}>
                      Texto e imagen
                    </Option>
                    <Option key={2} value={2}>
                      Sólo texto
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem
                  label="Descripción *"
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                >
                  <TextArea
                    rows={4}
                    required
                    placeholder="Descripción de la notificación"
                    value={this.state.description}
                    onChange={this.onChangeDescription}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Imagen (750x502 .png)"
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                >
                  <input
                    type="file"
                    onChange={event => {
                      this.handlChangeImage(event.target.files)
                    }}
                  />
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Card>

        <Button
          block
          type="primary"
          style={{height: 50, fontSize: 18}}
          onClick={this.onPressSend}
        >
          ENVIAR
        </Button>
      </React.Fragment>
    )
  }
}

function getIdNotification({
  dateFrom,
  dateTo,
  title,
  subTitle,
  description,
  typeNotification,
  destiny,
  idsSelected,
  tokensSelected,
  idCompany,
  imageUrl,
}) {
  const formData = new FormData()
  formData.append('date_from', dateFrom)
  formData.append('date_to', dateTo)
  formData.append('title', title)
  formData.append('subtitle', subTitle)
  formData.append('description', description)
  formData.append('type', typeNotification)
  formData.append('audience', destiny)
  formData.append('vendors_ids', idsSelected)
  formData.append('tokens_ids', tokensSelected)
  formData.append('company_id', idCompany)
  formData.append('photo_data', imageUrl)
  formData.append('command', 'uploadNotifications')

  const config = {
    headers: {'Content-Type': 'multipart/form-data'},
  }
  const url = `https://appvendedores.comprasdavivienda.cr/resources/ws/imageapi/`

  const request = axios.post(url, formData, config).then(res => {
    return {
      success: res.data.successful,
      notificationId: res.data.notificationId,
    }
  })

  return request
}

async function _getDataVendors() {
  try {
    let response = await fetch(
      `https://appvendedores.comprasdavivienda.cr/resources/ws/getVendorsWithTokens.php/`,
    )
    let data = await response.json()
    return data
  } catch (error) {
    return null
  }
}

function mapStateToProps({reports, companiesInfo}) {
  const {companies} = companiesInfo

  return {
    companies,
  }
}

export default connect(
  mapStateToProps,
  {fetchDataCompanies, fetchCompanies},
)(DestinationData)



// WEBPACK FOOTER //
// ./src/routes/main/Notifications/DestinationData.js